import React, { useState } from "react";
import Button from "../../../Components/Common/Button";
import Input from "../../../Components/Common/Input";
import useSWRMutation from "swr/mutation";
import { AuthUrls } from "../../../Api/Auth/ApiUrls";
import { sendPostRequest } from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../hooks/useErrorToast";
import { Link, useNavigate } from "react-router-dom";

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    resetCode: "",
  });
  const [errors, setErrors] = useState({});
  const { showErrorToast } = useToastError();

  // SWR mutation hook to handle the form submission login
  const { trigger, isMutating } = useSWRMutation(
    AuthUrls.resetPassword,
    sendPostRequest,
    {
      onSuccess: () => {
        toast.success("Success");
        navigate("/login");
      },
      onError: (error) => {
        console.log(error);

        showErrorToast(error);
        // console.log(error);
      },
    }
  );

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple validation
    const validationErrors = {};
    if (!formData.email) validationErrors.email = "Email is required.";
    if (!formData.resetCode)
      validationErrors.resetCode = "Reset Code is required.";
    if (!formData.password) validationErrors.password = "Password is required.";
    if (!formData.confirmPassword)
      validationErrors.confirmPassword = "Confirm password is required.";
    else if (formData.confirmPassword !== formData.password)
      validationErrors.confirmPassword = "Passwords do not match.";
    setErrors(validationErrors);

    // Handle form submission if there are no errors
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }
    trigger(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="font-regular">
        A 6 digit code has been sent to your email address
      </h2>

      {/* Email Field */}

      <Input
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        placeholder="Enter your email"
        error={errors.email}
        required
      />

      {/* Reset cCde Field */}

      <Input
        label="Reset Code"
        type="text"
        name="resetCode"
        value={formData.resetCode}
        onChange={handleInputChange}
        placeholder="Enter your reset code"
        error={errors.resetCode}
        required
      />

      {/* Password Field */}

      <Input
        label="Password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleInputChange}
        placeholder="Enter your password"
        error={errors.password}
        required
      />

      {/*Reset Password Field */}

      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={handleInputChange}
        placeholder="Confirm your password"
        error={errors.confirmPassword}
        required
      />

      <div className="flex items-center gap-4">
        <Button type="primary" isLoading={isMutating}>
          Submit
        </Button>
        <Link to="/login">
          <Button type="outline">Cancel</Button>
        </Link>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
